<script>
import baseMixin from '@/mixins/baseMixin'
import { SelectField } from '@/models/forms/fields/selectField'
import InfoLabel from '../general/info-label.vue'

export default {
  name: 'FormSubmissionSelectField',
  components: {
    InfoLabel,
  },
  mixins: [baseMixin],
  props: {
    field: {
      type: SelectField,
      required: true,
    },
    value: {
      type: Number,
      default: -1,
    },
  },
  computed: {
    compSelection() {
      const selection = this.field.options.find(
        (option) => option.value === this.value
      )

      if (!selection) return ''

      return selection.displayText
    },
  },
}
</script>

<template>
  <div>
    <InfoLabel :label="field.label">
      <v-chip-group v-if="compSelection">
        <v-chip> {{ compSelection }}</v-chip>
      </v-chip-group>
    </InfoLabel>
  </div>
</template>
